export const data = [
  {
    id: 1,
    title: 'Increasing Prosperity With Positive Thinking',
    imageURL: './src/img/strategies/1.jpg',
    tags: ['Art', 'Design'],
    text:
      'Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?',
    date: '01.01.2022',
  },
  {
    id: 2,
    title: 'Motivation Is The First Step To Success',
    imageURL: './src/img/strategies/2.jpg',
    tags: ['Culture'],
    text:
      'Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?',
    date: '01.01.2022',
  },
  {
    id: 3,
    title: 'Success Steps For Your Personal Or Business Life',
    imageURL: './src/img/strategies/3.jpg',
    tags: ['Culture', 'Design', 'Art'],
    text:
      'Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?',
    date: '01.01.2022',
  },
  {
    id: 4,
    title: 'Success Steps For Your Personal Or Business Life Plus Funny Image on the Back',
    imageURL: './src/img/strategies/4.jpg',
    tags: ['Culture', 'Design', 'Art'],
    wide: true,
    text:
      'Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?',
    date: '01.01.2022',
  },
  {
    id: 5,
    title: 'Increasing Prosperity With Positive Thinking',
    imageURL: './src/img/strategies/5.jpg',
    tags: ['Design'],
    text:
      'Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?',
    date: '01.01.2022',
  },
  {
    id: 6,
    title: 'Increasing Prosperity With Positive Thinking',
    imageURL: './src/img/strategies/1.jpg',
    tags: ['Art', 'Design'],
    text:
      'Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?',
    date: '01.01.2022',
  },
  {
    id: 7,
    title: 'Motivation Is The First Step To Success',
    imageURL: './src/img/strategies/2.jpg',
    tags: ['Culture'],
    text:
      'Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?',
    date: '01.01.2022',
  },
  {
    id: 8,
    title: 'Success Steps For Your Personal Or Business Life',
    imageURL: './src/img/strategies/3.jpg',
    tags: ['Culture', 'Design', 'Art'],
    text:
      'Knowing yourself is the first, and a very critical step in the process of planning your future. How can you figure out what you want to do with your life if you don’t know: What am I going to do with the  rest of my life? What is my dream job? What do I enjoy doing? What’s my passion? What kind of career fits my personality?',
    date: '01.01.2022',
  },
];
